import { GetServerSideProps } from "next";
import { serverSideTranslations } from "../../../common/utility/serverSideTranslations";
import { getSelectorsByUserAgent } from "react-device-detect";
import BlogCategoryPage from "../../../domains/blog/pages/blogCategory/blogCategoryPage";
import { saveContentLangToCookie } from "../../../common/services/utilityService";
import { getWpGraphqlClientFunctions } from "@kunduz/data-access-wp-graphql";
import { getCachedHeaderItems } from "../../../common/services/cachedHeaderItems";
import { getCachedHeaderBanner } from "../../../common/services/cachedHeaderBanner";

export default function Index(props) {
  return <BlogCategoryPage {...props} />;
}

export const getServerSideProps: GetServerSideProps = async ({
  req,
  res,
  locale,
  query,
  params,
}) => {
  const { before, after } = query;
  const { isMobile } = getSelectorsByUserAgent(req.headers["user-agent"]);
  const { kz_user_token } = req.cookies;

  const wordpressFunctions = getWpGraphqlClientFunctions();

  const categoryPostsResponse = await wordpressFunctions.getCategoryPosts(
    after || !before ? 12 : undefined,
    before && 12,
    before as string,
    after as string,
    params.categorySlug as string,
  );

  if (!categoryPostsResponse.category) {
    return {
      notFound: true,
    };
  }

  if (
    locale != "tr" &&
    categoryPostsResponse.category.language.code === "TR_TR"
  ) {
    const destination = `/tr/blog/category/${params.categorySlug}/`;
    return { redirect: { permanent: true, destination: destination } };
  }

  const headerItems = await getCachedHeaderItems(locale, "student");
  const headerBanner = await getCachedHeaderBanner(locale);

  saveContentLangToCookie(locale, { res });

  return {
    props: {
      posts: categoryPostsResponse.nodes,
      pageInfo: categoryPostsResponse.pageInfo,
      category: categoryPostsResponse.category,
      locale,
      isMobile,
      lang: locale,
      headerItems,
      isAuth: !!kz_user_token,
      headerBanner,
      ...(await serverSideTranslations(locale, [
        "questionIndexing",
        "kunduzcom_common",
        "kunduzcom_blog",
      ])),
    },
  };
};
